import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            columns_for_tables: {
              tab_name: 'TAB_NAME',
              tables: 'TABLES',
            },
          },
        },
      },
    },
  }));
}
